import React,{Component} from 'react';
import Slider from "react-slick";

const categoryList = [
    {   
        imageUrl: 'gp-1.png',
        name: 'Oils, Refined &  Ghee',
    },
    {   
        imageUrl: 'gp-8.png',
        name: 'Chocolates & Sweets  Nuts',
    },
    {   
        imageUrl: 'gp-2.png',
        name: 'Dry Fruits,  Nuts & Seeds',
    },
    {   
        imageUrl: 'gp-3.png',
        name: 'Well Common  Pharma',
    },
    {   
        imageUrl: 'gp-4.png',
        name: 'Instant Drink  Mixes',
    },
    {   
        imageUrl: 'gp-5.png',
        name: 'Chips Namkeen &  Snacks',
    },
    {   
        imageUrl: 'gp-6.png',
        name: 'Cooking Sauces  Vinegar',
    },
    {   
        imageUrl: 'gp-7.png',
        name: 'Packaged Food &  Fruits',
    },
]

class Catagorysldier extends Component {
    render() {
        const storysettings = {
            arrows: false,
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            centerMode: false,
            variableWidth: true
        };
        return (
            <Slider {...storysettings} className="slick-arrow-top">
                {categoryList.map((value , index) => (
                    <div key={index} className="me-2">
                        <div className="category-card w-110 style-three shadow-none text-center bg-transparent border-0">
                            <a href="/g-6" className="rounded-circle hover-zoom pt-1 image-round after-none"><img src={`assets/images/${value.imageUrl}`} className="w-85" alt="category" /></a>
                            <h4 className="font-xssss text-grey-600 mt-2 fw-700 d-block lh-18">{value.name}</h4>
                        </div>
                    </div>
                ))}
            </Slider>
        );
    }
}

export default Catagorysldier;